// store.js
import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import storage from 'redux-persist/lib/storage'
import { persistStore, persistReducer } from 'redux-persist';
import rootReducer from './Reducers'; // You'll create this
import thunk from 'redux-thunk';

const persistConfig = {
    key: 'root',
    storage,
};
const axiosInstance = {}

const persistedReducer = persistReducer(persistConfig, rootReducer);
// Custom logger middleware
const logger = store => next => action => {
    console.group(action.type);
    console.log('Previous state:', store.getState());
    console.log('Action:', action);
    const result = next(action);
    console.log('Next state:', store.getState());
    console.groupEnd();
    return result;
};
const actionLoggerMiddleware = store => next => action => {
    // if (["USER_SEARCH_DATA", "USER_SEARCH_DATA_ERROR"].includes(action.type)) {
    if (["TOUR_SEARCH_DATA"].includes(action.type)) {
        console.log('🔁 Redux Action Dispatched:', action.type);
        console.trace();  // Shows call stack (source line & file)
    }
    return next(action);
};
const store = createStore(
    persistedReducer,
    applyMiddleware(thunk.withExtraArgument(axiosInstance), actionLoggerMiddleware),
);



export default store;
